import React from "react";
import SetTitle from "../../components/SetTitle";
import E1 from "../../assets/images/E1.webp";
import E2 from "../../assets/images/E2.webp";
import E3 from "../../assets/images/E3.webp";
import E4 from "../../assets/images/E4.webp";
import E5 from "../../assets/images/E5.webp";
import E6 from "../../assets/images/E6.webp";
import E7 from "../../assets/images/E7.webp";
import E8 from "../../assets/images/E8.webp";
import E9 from "../../assets/images/E9.webp";
import styles from "./EarlyChildrenEducation.module.scss";

const EarlyChildrenEducation = () => {
	SetTitle("Early Children Education");

	return (
		<div className={styles.EarlyChildrenEducation}>
			<h2>Early Childhood Education </h2>
			<div className={styles.ContainerLeft}>
				<div className={styles.Left}>
					<h3>A Learning Environment</h3>
					<span></span>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
						maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur
						adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
						Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
						Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit ipsum dolor sit amet,
						consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique{" "}
					</p>
				</div>
				<div className={styles.Right}>
					<img src={E1} alt="" />
				</div>
			</div>

			<div className={styles.ContainerRight}>
				<div className={styles.Left}>
					<img src={E2} alt="" />
				</div>
				<div className={styles.Right}>
					<h3>activity oriented</h3>
					<span></span>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
						maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur
						adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
						Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
						Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit ipsum dolor sit amet,
						consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique{" "}
					</p>
				</div>
			</div>

			<div className={styles.ContainerLeft}>
				<div className={styles.Left}>
					<h3>Play way method</h3>
					<span></span>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
						maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur
						adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
						Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
						Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit ipsum dolor sit amet,
						consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique{" "}
					</p>
				</div>
				<div className={styles.Right}>
					<img src={E3} alt="" />
				</div>
			</div>

			<div className={styles.ContainerRight}>
				<div className={styles.Left}>
					<img src={E4} alt="" />
				</div>
				<div className={styles.Right}>
					<h3>development of creative expression & aesthetic appreciation</h3>
					<span></span>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
						maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur
						adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
						Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
						Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit ipsum dolor sit amet,
						consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique{" "}
					</p>
				</div>
			</div>

			<div className={styles.ContainerLeft}>
				<div className={styles.Left}>
					<h3>INTELLECTUAL & COGNITIVE DEVELOPMENT</h3>
					<span></span>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
						maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur
						adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
						Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
						Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit ipsum dolor sit amet,
						consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique{" "}
					</p>
				</div>
				<div className={styles.Right}>
					<img src={E5} alt="" />
				</div>
			</div>

			<div className={styles.ContainerRight}>
				<div className={styles.Left}>
					<img src={E6} alt="" />
				</div>
				<div className={styles.Right}>
					<h3>LANGUAGE DEVELOPMENT</h3>
					<span></span>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
						maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur
						adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
						Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
						Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit ipsum dolor sit amet,
						consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique{" "}
					</p>
				</div>
			</div>

			<div className={styles.ContainerLeft}>
				<div className={styles.Left}>
					<h3>EMOTIONAL DEVELOPMENT</h3>
					<span></span>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
						maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur
						adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
						Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
						Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit ipsum dolor sit amet,
						consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique{" "}
					</p>
				</div>
				<div className={styles.Right}>
					<img src={E7} alt="" />
				</div>
			</div>

			<div className={styles.ContainerRight}>
				<div className={styles.Left}>
					<img src={E8} alt="" />
				</div>
				<div className={styles.Right}>
					<h3>PHYSICAL & MOTOR DEVELOPMENT</h3>
					<span></span>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed
						maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur
						adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
						Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
						Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit ipsum dolor sit amet,
						consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique{" "}
					</p>
				</div>
			</div>

			<div className={styles.FullContainer}>
				<img src={E9} alt="" />
				<h3>Theme based Learning</h3>
				<span></span>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas
					tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit.
					Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit
					amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt
					cras. Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
					mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum
					dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique
					tincidunt cras. Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur
					curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor
					sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique
					tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis
					ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulumem ipsum dolor sit amet,
					consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt cras.
					Vestibulum tincidunt sit tincidunt sit Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut
					curabitur curabitur leo. Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit Lorem ipsum dolor sit
					amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo. Sed maecenas tristique tincidunt
					cras. Vestibulumem ipsum dolor sit amet, consectetur adipiscing elit. Duis mollis ut curabitur curabitur leo.
					Sed maecenas tristique tincidunt cras. Vestibulum tincidunt sit tincidunt sit
				</p>
			</div>
		</div>
	);
};

export default EarlyChildrenEducation;
